export const i18nModelPage = {
  sections: {
    risk: 'Puntuación de Riesgo',
    alarmHistory: 'Historial de Alarmas',
    radar: 'Radar view',
    amoeba: 'Plot view',
    models: 'Modelos de Proceso',
  },
};
